export const DeleteBtnIcon = ({ stroke = "#15112D" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66667 5.00008V3.33341C6.66667 2.41294 7.41286 1.66675 8.33333 1.66675H11.6667C12.5872 1.66675 13.3333 2.41294 13.3333 3.33341V5.00008M2.5 5.00008H17.5H2.5ZM4.16667 5.00008V16.6667C4.16667 17.5872 4.91286 18.3334 5.83333 18.3334H14.1667C15.0872 18.3334 15.8333 17.5872 15.8333 16.6667V5.00008H4.16667Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.666 9.16675V14.1667"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33398 9.16675V14.1667"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
